export interface ReplayItem {
  id: string;
  title: string;
  host: string;
  category: string;
  dateLabel: string;
  duration: string;
  plays: number;
  cover: string;
  summary: string;
}

export const replays: ReplayItem[] = [
  {
    id: 'replay-night-talk-0909',
    title: '爆料夜话回顾：剧组换角风波的前前后后',
    host: '苏念',
    category: '娱乐爆料',
    dateLabel: '09-09',
    duration: '58 分钟',
    plays: 128400,
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20amber%20talk%20show%20studio%20with%20velvet%20sofa%20and%20soft%20lamp%20glow%2C%20deep%20brown%20tones%2C%20cinematic%20editorial%20photography%2C%20elegant%20intimate%20mood&width=900&height=560&seq=bl-replay-01&orientation=landscape',
    summary: '把换角传闻的时间线、双方公开回应和行业惯例放在一起讲，最后给出理性看待的几种可能。',
  },
  {
    id: 'replay-market-week-0908',
    title: '财经复盘：一周市场信号完整解读',
    host: '沈立',
    category: '财经观察',
    dateLabel: '09-08',
    duration: '76 分钟',
    plays: 86200,
    cover:
      'https://readdy.ai/api/search-image?query=Financial%20review%20workspace%20at%20night%20with%20amber%20desk%20lamp%20and%20chart%20monitors%2C%20dark%20wood%20office%2C%20professional%20editorial%20photography%2C%20warm%20brown%20palette&width=900&height=560&seq=bl-replay-02&orientation=landscape',
    summary: '按周维度梳理本周被反复讨论的几个信号，说明它们和普通人生活的关系，不做任何投资建议。',
  },
  {
    id: 'replay-home-storage-0907',
    title: '好物专场：换季收纳好物清单实测',
    host: '林小满',
    category: '生活好物',
    dateLabel: '09-07',
    duration: '64 分钟',
    plays: 71500,
    cover:
      'https://readdy.ai/api/search-image?query=Neat%20home%20storage%20shelf%20with%20woven%20baskets%20and%20warm%20amber%20daylight%2C%20clean%20minimal%20lifestyle%20photography%2C%20beige%20and%20brown%20tones%2C%20soft%20shadows&width=900&height=560&seq=bl-replay-03&orientation=landscape',
    summary: '十件收纳单品逐件上手，比较承重、叠放稳定性和取用顺手度，并给出小户型搭配建议。',
  },
  {
    id: 'replay-esports-final-0906',
    title: '电竞复盘：半决赛打满五局的细节解析',
    host: '阿凯',
    category: '游戏电竞',
    dateLabel: '09-06',
    duration: '92 分钟',
    plays: 163700,
    cover:
      'https://readdy.ai/api/search-image?query=Esports%20analysis%20room%20with%20tactical%20charts%20on%20big%20screens%20and%20amber%20accent%20light%2C%20dark%20moody%20interior%2C%20cinematic%20editorial%20photography&width=900&height=560&seq=bl-replay-04&orientation=landscape',
    summary: '逐局回看关键团战的站位与决策，指出两次转折点分别是怎么发生的，适合想学思路的观众。',
  },
  {
    id: 'replay-tech-foldable-0905',
    title: '科技圆桌：折叠屏三年之痒聊透',
    host: '周叙',
    category: '科技前沿',
    dateLabel: '09-05',
    duration: '81 分钟',
    plays: 94800,
    cover:
      'https://readdy.ai/api/search-image?query=Minimal%20tech%20discussion%20table%20with%20foldable%20devices%20under%20warm%20amber%20spotlights%2C%20dark%20neutral%20studio%2C%20editorial%20product%20photography%2C%20high%20detail&width=900&height=560&seq=bl-replay-05&orientation=landscape',
    summary: '从铰链、折痕到软件适配，聊清楚这三年折叠屏解决了什么、还剩下哪些没解决的老问题。',
  },
  {
    id: 'replay-music-return-0904',
    title: '音乐现场：城市民谣专场返场篇',
    host: '江迟',
    category: '音乐现场',
    dateLabel: '09-04',
    duration: '55 分钟',
    plays: 67200,
    cover:
      'https://readdy.ai/api/search-image?query=Intimate%20acoustic%20music%20stage%20with%20guitar%20and%20warm%20amber%20spotlight%2C%20dark%20velvet%20backdrop%2C%20cinematic%20concert%20photography%2C%20rich%20warm%20tones&width=900&height=560&seq=bl-replay-06&orientation=landscape',
    summary: '应观众要求加场的返场直播，七首长篇民谣连唱，中间聊了聊巡演路上遇到的小事。',
  },
  {
    id: 'replay-emotion-boundary-0903',
    title: '情感夜话：亲密关系里的边界感怎么谈',
    host: '温言',
    category: '情感夜话',
    dateLabel: '09-03',
    duration: '70 分钟',
    plays: 82100,
    cover:
      'https://readdy.ai/api/search-image?query=Calm%20late%20night%20reading%20corner%20with%20warm%20amber%20lamp%20and%20soft%20chair%2C%20muted%20brown%20beige%20palette%2C%20gentle%20minimal%20editorial%20photography&width=900&height=560&seq=bl-replay-07&orientation=landscape',
    summary: '回放里整理了三段来信和对应的沟通话术示范，讲清楚表达需求时怎样不把对方推远。',
  },
  {
    id: 'replay-sports-highlight-0902',
    title: '赛事回看：焦点战全场精华与战术板',
    host: '韩枫',
    category: '体育赛事',
    dateLabel: '09-02',
    duration: '68 分钟',
    plays: 104900,
    cover:
      'https://readdy.ai/api/search-image?query=Sports%20tactics%20board%20session%20in%20a%20warm%20amber%20lit%20studio%20with%20match%20footage%20on%20screen%2C%20dark%20elegant%20wood%20interior%2C%20cinematic%20photography&width=900&height=560&seq=bl-replay-08&orientation=landscape',
    summary: '浓缩全场关键回合，用战术板还原两次进攻组织的跑位路线，看完基本能看懂整场走势。',
  },
];